import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  selectionIcon: {
    borderRadius: '50%',
    width: 30,
    height: 30,
    objectFit: 'cover',
  },
  selectionIconButton: {
    '&&': {
      padding: 4,
      marginLeft: -8,
    },
  },
  selectionWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 98,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '8px',
    justifyContent: 'center',
  },
  imageWrapperProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
